import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NavbarDropdownItems } from "./NavbarDropdownItems";
import "./NavbarDropdown.css";

function NavbarDropdown({ onClickEvent = () => {} }) {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);

  return (
    <ul
      onClick={handleClick}
      className={click ? "dropdown-menu clicked" : "dropdown-menu"}
    >
      {NavbarDropdownItems.map((item, index) => {
        return (
          <li key={index}>
            <Link
              className={item.cName}
              to={item.path}
              onClick={() => {
                setClick(false);
                onClickEvent();
              }}
            >
              {item.title}
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

export default NavbarDropdown;
